<template>
    <div>
        <v-card
            :elevation=elevation
            :class=classCard
            style='-webkit-box-shadow: 5px 3px 16px -8px rgba(0,0,0,0.74); box-shadow: 5px 3px 16px -8px rgba(0,0,0,0.74);'
            :to=link
            @click="$emit('diag',true)"
        >
            <v-row 
                class='mx-0' 
                align="center"
                justify="center"
            >
                <v-col cols="3" md=2 :class="`text-center ${background} border-card-services`">
                    <v-img 
                        :src="`${icon}`" 
                        style="width:80px;margin:0 auto"
                    />
                </v-col>
                <v-col cols="9" md=10 class='text-md-left text-center pl-md-4 pl-0"'>
                    <span class='' v-html="title"></span>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog
            v-model="dialog"
            width="500"
            persistent
        >
            <v-card>
                <v-card-title class="text-right pb-0" style="display: block;">               
                    <v-btn
                        color="primary"
                        text
                        x-small
                        @click="$emit('diag',false)"
                        class="gray--text"
                    >
                        <v-icon small>mdi-close</v-icon>  Cerrar
                    </v-btn>
                </v-card-title>
                <v-card-text v-html=content></v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name:'CardServiciosComponent',
    props:{
        icon:{
            type: String,
            default:''
        },
        title:{
            type: String,
            default:''
        },
        background:{
            type: String,
            default:'primary'
        },
        classCard:{
            type: String,
            default:''
        },
        elevation:{
            type: String,
            default:''
        },
        link:{
            type: String,
            default: ''
        },
        dialog:{
            type: Boolean,
            default:false
        },
        content:{
            type: String,
            default: ''
        }
    }
}
</script>

<style>
    .border-card-services{
        border-top-left-radius: 10px!important;
        border-bottom-left-radius: 10px!important;
    }

    

</style>